import type { RegistrationTransformedValues } from "@/components/RegistrationForm";
import { useCreateRegistrationMutation } from "@/mutations/registration.ts";
import { useQueryOptionsFactory } from "@/queries";
import { defaultMutationErrorHandler } from "@/utils/api.ts";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { enqueueSnackbar } from "notistack";
import { type ReactNode, useCallback, useState } from "react";
import RegistrationDialog from "./-components/RegistrationDialog.tsx";

const Root = (): ReactNode => {
    const qof = useQueryOptionsFactory();
    const { auctionId } = Route.useParams();
    const auction = useSuspenseQuery(qof.auction.get(auctionId)).data;
    const navigate = Route.useNavigate();
    const createMutation = useCreateRegistrationMutation();
    const [open, setOpen] = useState(true);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    const handleSubmit = useCallback(
        (values: RegistrationTransformedValues) => {
            createMutation.mutate(
                { auctionId, authenticated: true, ...values },
                {
                    onSuccess: () => {
                        enqueueSnackbar("Registration has been created", { variant: "success" });
                        setOpen(false);
                    },
                    onError: defaultMutationErrorHandler,
                },
            );
        },
        [createMutation, auctionId],
    );

    return (
        <RegistrationDialog
            title="Create new registration"
            open={open}
            onClose={handleClose}
            auction={auction}
            navigate={navigate}
            onSubmit={handleSubmit}
        />
    );
};

export const Route = createFileRoute("/manage/auctions/$auctionId/registrations/create")({
    component: Root,
});
